<template>
	<!-- Sidebar fissa stile "filtri pinnati": desktop registra lo spazio (app+permanent),
	     mobile diventa un drawer temporary con scrim (chiusura al tap fuori) -->
	<v-navigation-drawer
		v-if="companyId"
		:value="true"
		@input="onDrawerInput"
		right
		fixed
		app
		:permanent="!isMobile"
		:stateless="!isMobile"
		:temporary="isMobile"
		:width="isMobile ? 340 : 400"
		class="products-history-drawer">
		<v-card-title class="pa-3 flex-shrink-0">
			<v-icon color="primary" class="mr-2">history</v-icon>
			<p class="mb-0">Storico prodotti</p>
			<v-spacer></v-spacer>
			<v-btn icon @click="$emit('close')">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>
		<v-divider></v-divider>

		<!-- Filtri (fissi: scrolla solo la lista) -->
		<v-container fluid class="py-2 px-3 flex-shrink-0">
			<v-text-field
				v-model="search"
				placeholder="Cerca prodotto o codice"
				prepend-inner-icon="search"
				hide-details
				dense
				outlined
				clearable
				class="mb-2 history-search-field"
			></v-text-field>

			<v-row dense class="ma-0">
				<v-col cols="6" class="pa-0 pr-1">
					<g-m-h-date-picker
						:value="from"
						label="Dal"
						:dense="true"
						:clearable="true"
						@input="from = $event; reload()"
					></g-m-h-date-picker>
				</v-col>
				<v-col cols="6" class="pa-0 pl-1">
					<g-m-h-date-picker
						:value="to"
						label="Al"
						:dense="true"
						:clearable="true"
						@input="to = $event; reload()"
					></g-m-h-date-picker>
				</v-col>
			</v-row>

			<v-btn-toggle
				v-model="mode"
				mandatory
				dense
				color="primary"
				class="d-flex mt-1"
				@change="onModeChange()">
				<v-btn value="grouped" small class="flex-grow-1">
					<v-icon small class="mr-1">mdi-format-list-group</v-icon>
					Aggregato
				</v-btn>
				<v-btn value="detail" small class="flex-grow-1">
					<v-icon small class="mr-1">mdi-calendar-text</v-icon>
					Per ordine
				</v-btn>
			</v-btn-toggle>

			<div class="d-flex align-center mt-2">
				<v-select
					v-model="sort"
					:items="sortOptions"
					label="Ordina per"
					prepend-inner-icon="mdi-sort"
					hide-details
					dense
					outlined
					class="history-sort-field flex-grow-1"
					@change="onSortChange"
				></v-select>
				<v-tooltip top>
					<template v-slot:activator="{ on }">
						<v-btn
							v-on="on"
							icon
							class="ml-1"
							@click="toggleDirection()">
							<v-icon>{{ direction === 'asc' ? 'mdi-sort-ascending' : 'mdi-sort-descending' }}</v-icon>
						</v-btn>
					</template>
					<span>{{ direction === 'asc' ? 'Crescente' : 'Decrescente' }}</span>
				</v-tooltip>
			</div>
		</v-container>
		<v-divider></v-divider>

		<!-- Lista -->
		<div class="history-rows">
			<v-progress-linear v-if="loading && rows.length === 0" indeterminate color="primary"></v-progress-linear>

			<p v-if="!loading && rows.length === 0" class="text-center grey--text py-6 body-2">
				Nessun prodotto ordinato da questo cliente
			</p>

			<v-list dense class="py-0 background-2">
				<template v-for="(row, index) in rows">
					<v-list-item :key="rowKey(row, index)" class="px-3 history-row">
						<v-list-item-content class="py-2">
							<v-list-item-title class="body-2 font-weight-medium">
								{{ row.name }}
								<v-tooltip top v-if="inOrder(row.product_id)">
									<template v-slot:activator="{ on }">
										<v-icon v-on="on" small color="success" class="ml-1">mdi-check-circle</v-icon>
									</template>
									<span>Già presente nell'ordine</span>
								</v-tooltip>
							</v-list-item-title>
							<v-list-item-subtitle class="caption">
								<template v-if="mode === 'grouped'">
									Ultimo: {{ $eventBusUtility.formatDate(row.last_date) }} × {{ formatQty(row.last_quantity) }}
									— {{ row.orders_count }} {{ row.orders_count == 1 ? 'ordine' : 'ordini' }}, tot {{ formatQty(row.total_quantity) }}
								</template>
								<template v-else>
									{{ $eventBusUtility.formatDate(row.date) }}
									<span v-if="row.saleorder_number"> — Ordine {{ row.saleorder_number }}</span>
									× {{ formatQty(row.quantity) }}
								</template>
								<span v-if="row.product_code"> — {{ row.product_code }}</span>
							</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-action class="my-1 flex-row align-center">
							<v-text-field
								v-model="row.add_quantity"
								type="number"
								min="0"
								dense
								hide-details
								outlined
								class="qty-input mr-1"
							></v-text-field>
							<v-btn
								icon
								small
								color="primary"
								:loading="row.adding"
								@click="addToOrder(row)">
								<v-icon>mdi-cart-plus</v-icon>
							</v-btn>
						</v-list-item-action>
					</v-list-item>
					<v-divider :key="'div-' + rowKey(row, index)"></v-divider>
				</template>
			</v-list>

			<div class="text-center py-2" v-if="hasMore">
				<v-btn text small color="primary" :loading="loading" @click="loadMore()">
					Carica altri
				</v-btn>
			</div>
		</div>
	</v-navigation-drawer>
</template>

<script>

	import Vue from 'vue'
	import GMHDatePicker from '@/components/common/GMHDatePicker'

	export default {
		name: 'saleorder-products-history-drawer',
		components: {
			GMHDatePicker
		},
		props: {
			// id del cliente selezionato nell'ordine
			companyId: [Number, String],
			// righe prodotto già presenti nell'ordine (per il badge "già in ordine")
			items: {
				type: Array,
				default: () => []
			},
			// funzione (productId, quantity) => Promise<boolean> che aggiunge la riga all'ordine
			addHandler: Function
		},

		data() {
			return {
				mode: 'grouped',
				sort: 'date',
				direction: 'desc',
				search: '',
				from: null,
				to: null,
				rows: [],
				page: 1,
				lastPage: 1,
				loading: false,
				searchTimeout: null,
				// scarta le risposte arrivate fuori ordine (cambio rapido di filtri/mode)
				lastRequestId: 0
			}
		},

		computed: {
			isMobile() {
				return this.$vuetify.breakpoint.smAndDown
			},

			sortOptions() {
				if(this.mode === 'grouped') {
					return [
						{value: 'date', text: 'Data ultimo ordine'},
						{value: 'name', text: 'Nome'},
						{value: 'code', text: 'Codice'},
						{value: 'most_ordered', text: 'N. ordini'},
						{value: 'total_quantity', text: 'Quantità totale'}
					]
				}
				return [
					{value: 'date', text: 'Data ordine'},
					{value: 'name', text: 'Nome'},
					{value: 'code', text: 'Codice'}
				]
			},

			hasMore() {
				return this.page < this.lastPage
			},

			productIdsInOrder() {
				return _.map(_.filter(this.items, (i) => i && i.product_id), 'product_id')
			}
		},

		watch: {
			companyId(val) {
				// cambio cliente: reset e ricarica dello storico
				if(val) {
					this.reload()
				} else {
					this.rows = []
				}
			},

			search() {
				clearTimeout(this.searchTimeout)
				this.searchTimeout = setTimeout(() => {
					this.reload()
				}, 400)
			}
		},

		methods: {

			// mobile: chiusura via scrim/swipe del drawer temporary
			onDrawerInput(val) {
				if(!val) {
					this.$emit('close')
				}
			},

			onModeChange() {
				// il sort corrente potrebbe non esistere nella nuova modalità
				if(!_.some(this.sortOptions, {value: this.sort})) {
					this.sort = 'date'
					this.direction = 'desc'
				}
				this.reload()
			},

			onSortChange() {
				// direzione di default sensata per il campo scelto
				this.direction = ['name', 'code'].includes(this.sort) ? 'asc' : 'desc'
				this.reload()
			},

			toggleDirection() {
				this.direction = this.direction === 'asc' ? 'desc' : 'asc'
				this.reload()
			},

			rowKey(row, index) {
				return this.mode + '-' + (this.mode === 'grouped' ? row.product_id : row.id) + '-' + index
			},

			reload() {
				this.page = 1
				this.rows = []
				this.fetch()
			},

			loadMore() {
				if(this.loading || !this.hasMore) return
				this.page++
				this.fetch()
			},

			fetch() {
				if(!this.companyId) return
				const requestId = ++this.lastRequestId
				const requestedPage = this.page
				this.loading = true

				this.axios.post('saleorders-products-history', {
					company_id: this.companyId,
					mode: this.mode,
					sort: this.sort,
					direction: this.direction,
					from: this.from,
					to: this.to,
					search: this.search,
					page: this.page,
					per_page: 30
				}).then(response => {
					// nel frattempo è partita una richiesta più recente: ignora
					if(requestId !== this.lastRequestId) return

					const paginator = response.data.data
					this.lastPage = paginator.last_page

					_.forEach(paginator.data, (row) => {
						// campo quantità stile ecommerce: default = quantità dell'ultimo ordine
						row.add_quantity = this.defaultQuantity(row)
						row.adding = false
						this.rows.push(row)
					})

					this.loading = false
				}, () => {
					if(requestId !== this.lastRequestId) return
					// "Carica altri" fallito: ripristina la pagina per poter riprovare
					if(requestedPage > 1) {
						this.page = requestedPage - 1
					}
					this.loading = false
				})
			},

			defaultQuantity(row) {
				const qty = this.mode === 'grouped' ? row.last_quantity : row.quantity
				const parsed = parseFloat(qty)
				return parsed > 0 ? this.formatQty(parsed) : 1
			},

			formatQty(value) {
				const parsed = parseFloat(value)
				if(isNaN(parsed)) return value
				// senza zeri decimali inutili (5.00000 → 5)
				return parseFloat(parsed.toFixed(5))
			},

			inOrder(productId) {
				return this.productIdsInOrder.includes(productId)
			},

			addToOrder(row) {
				const quantity = parseFloat(String(row.add_quantity).replace(',', '.'))
				if(isNaN(quantity) || quantity <= 0) {
					this.$store.commit('setSnackbar', {timeout: 4000, text: 'Quantità non valida', value: true, color: 'error'})
					return
				}
				if(typeof this.addHandler !== 'function') return

				Vue.set(row, 'adding', true)
				this.addHandler(row.product_id, quantity).then((added) => {
					Vue.set(row, 'adding', false)
					if(added) {
						this.$store.commit('setSnackbar', {timeout: 3000, text: row.name + ' aggiunto all\'ordine', value: true, color: 'success'})
					} else {
						this.$store.commit('setSnackbar', {timeout: 4000, text: 'Impossibile aggiungere il prodotto', value: true, color: 'error'})
					}
				}, () => {
					Vue.set(row, 'adding', false)
					this.$store.commit('setSnackbar', {timeout: 4000, text: 'Impossibile aggiungere il prodotto', value: true, color: 'error'})
				})
			}
		},

		mounted() {
			this.fetch()
		},

		beforeDestroy() {
			clearTimeout(this.searchTimeout)
		}
	}
</script>

<style scoped>
	/* z-index 6 = quello standard dei navigation drawer Vuetify (vedi AdvancedFiltersDrawer):
	   i popup dei pulsanti in navbar partono da 8 e restano sopra la sidebar. */
	.products-history-drawer {
		z-index: 6 !important;
		top: 64px !important; /* altezza app-bar */
		height: calc(100vh - 64px) !important;
		padding-top: 0 !important;
	}

	/* Mobile (drawer temporary): pannello a tutta altezza, sopra la navbar come un menu */
	@media (max-width: 959px) {
		.products-history-drawer {
			top: 0 !important;
			height: 100vh !important;
			z-index: 8 !important;
		}
	}

	/* Header e filtri fissi: scrolla solo la lista */
	.products-history-drawer ::v-deep .v-navigation-drawer__content {
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.history-rows {
		flex: 1 1 auto;
		min-height: 0;
		overflow-y: auto;
	}

	.qty-input {
		max-width: 72px;
	}

	.qty-input ::v-deep input {
		padding: 4px 0;
		text-align: center;
	}

	.history-row ::v-deep .v-list-item__action {
		flex-direction: row;
		align-items: center;
	}

	/* Lente centrata verticalmente nel campo di ricerca dense */
	.history-search-field ::v-deep .v-input__prepend-inner,
	.history-sort-field ::v-deep .v-input__prepend-inner {
		margin-top: 0 !important;
		align-self: center;
	}
</style>
